import * as React from 'react';
import { Trans } from 'react-i18next';

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

import { Categories, ModuleTypes } from './ModuleInfo';

let ModuleUIInfo:{[key in ModuleTypes]?:{
	name?: React.ReactNode
	type: ModuleTypes
	subTitle?: React.ReactNode
	icon?: string
	category: Categories
	description?: React.ReactNode
	isHidden?: boolean
}} = {};

ModuleUIInfo[ModuleTypes.ImageUpload] = {
	name: <T>Upload new image</T>,
	subTitle: <T>Recommended DPI: 150 <br/> Max size: 120MP <br/> File types: JPG, PNG </T>,
	icon: "add",
	type: ModuleTypes.ImageUpload,
	category: Categories.Images,
}

ModuleUIInfo[ModuleTypes.Image] = {
	name: <T>My library</T>,
	icon: "my-library",
	type: ModuleTypes.Image,
	category: Categories.Images,
}

ModuleUIInfo[ModuleTypes.PatternDesignService] = {
	type: ModuleTypes.PatternDesignService,
	category: Categories.Images,
	name: <T>patterndesigns.com library</T>,
	icon: "pattern-designs",
}

ModuleUIInfo[ModuleTypes.WallpaperGroups] = {
	name: <T>Repeat Patterns</T>,
	type: ModuleTypes.WallpaperGroups,
	category: Categories.Transforms,
	description: <T>Tiles the layer using one of the wallpaper groups</T>,
	isHidden: true
}

ModuleUIInfo[ModuleTypes.Circle] = {
	name: <T>Circle</T>,
	type: ModuleTypes.Circle,
	category: Categories.Shapes,
	description: <T>A circle</T>,
}

ModuleUIInfo[ModuleTypes.Rectangle] = {
	name: <T>Rectangle</T>,
	type: ModuleTypes.Rectangle,
	category: Categories.Shapes,
	description: <T>A circle</T>,
}

ModuleUIInfo[ModuleTypes.Polygon] = {
	name: <T>Polygon</T>,
	type: ModuleTypes.Polygon,
	category: Categories.Shapes,
	description: <T>A polygon</T>,
}


ModuleUIInfo[ModuleTypes.Kaleidoscope] = {
	name: <T>Kaleidoscope</T>,
	type: ModuleTypes.Kaleidoscope,
	category: Categories.Transforms,
	description: <T>Adds a kaleidoscope effect to the layer</T>,
	icon: "repeat_kaleidoscope",
}

ModuleUIInfo[ModuleTypes.BrightnessContrast] = {
	name: <T>Brightness & Contrast</T>,
	type: ModuleTypes.BrightnessContrast,
	category: Categories.Effects,
	description: <T>Adds controls for brightness/contrast to the layer</T>,
}

ModuleUIInfo[ModuleTypes.Hue] = {
	name: <T>Hue</T>,
	type: ModuleTypes.Hue,
	category: Categories.Effects,
	description: <T>Adds controls for hue to the layer</T>,
}

ModuleUIInfo[ModuleTypes.Saturation] = {
	name: <T>Saturation</T>,
	type: ModuleTypes.Saturation,
	category: Categories.Effects,
	description: <T>Adds controls for saturation to the layer</T>,
}

ModuleUIInfo[ModuleTypes.Pixelate] = {
	name: <T>Pixelate</T>,
	type: ModuleTypes.Pixelate,
	category: Categories.Effects,
	description: <T>Pixelates the layer</T>,
}

export default ModuleUIInfo

export enum ModuleUIInfoSettingTypes {
	WallpaperRepeatsDot				 = "MODULE_TYPE_WALLPAPER_REPEATS_DOT",
	WallpaperRepeatsHalfBrick		 = "MODULE_TYPE_WALLPAPER_REPEATS_HALF_BRICK",
	WallpaperRepeatsMirrorHorizontal = "MODULE_TYPE_WALLPAPER_REPEATS_MIRROR_HORIZONTAL",
	WallpaperRepeatsMirrorVertical	 = "MODULE_TYPE_WALLPAPER_REPEATS_MIRROR_VERTICAL",
	WallpaperRepeatsMirror6way		 = "MODULE_TYPE_WALLPAPER_REPEATS_MIRROR_6WAY",
	WallpaperRepeats4wayangled		 = "MODULE_TYPE_WALLPAPER_REPEATS_4WAY_ANGLED",
	WallpaperRepeatsHalfdrop		 = "MODULE_TYPE_WALLPAPER_REPEATS_HALF_DROP",
	WallpaperRepeatsMirror4way		 = "MODULE_TYPE_WALLPAPER_REPEATS_MIRROR_4WAY",
}

let ModuleUIInfoSetting:{[key in ModuleUIInfoSettingTypes]?:{
	name?: React.ReactNode
	icon?: string
	category: Categories
	value?: boolean | string | number
	type: ModuleTypes
}} = {};

ModuleUIInfoSetting[ModuleUIInfoSettingTypes.WallpaperRepeatsHalfdrop] = {
	type: ModuleTypes.WallpaperGroups,
	category: Categories.Transforms,
	name: <T>Half-drop</T>,
	icon: "repeat_halfdrop",
	value:"17"
}

ModuleUIInfoSetting[ModuleUIInfoSettingTypes.WallpaperRepeatsHalfBrick] = {
	type: ModuleTypes.WallpaperGroups,
	category: Categories.Transforms,
	name: <T>Half-Brick</T>,
	icon: "repeat_halfbrick",
	value: "18"
}

ModuleUIInfoSetting[ModuleUIInfoSettingTypes.WallpaperRepeatsDot] = {
	type: ModuleTypes.WallpaperGroups,
	category: Categories.Transforms,
	name: <T>Dot repeat</T>,
	icon: "repeat_dot",
	value: "19"
}

ModuleUIInfoSetting[ModuleUIInfoSettingTypes.WallpaperRepeatsMirrorHorizontal] = {
	type: ModuleTypes.WallpaperGroups,
	category: Categories.Transforms,
	name: <T>Mirror Horizontal (pm)</T>,
	icon: "repeat_mirror",
	value: "2"
}

ModuleUIInfoSetting[ModuleUIInfoSettingTypes.WallpaperRepeatsMirrorVertical] = {
	type: ModuleTypes.WallpaperGroups,
	category: Categories.Transforms,
	name: <T>Mirror Vertical (pm)</T>,
	icon: "repeat_mirror_vertical",
	value: "20"
}

ModuleUIInfoSetting[ModuleUIInfoSettingTypes.WallpaperRepeatsMirror4way] = {
	type: ModuleTypes.WallpaperGroups,
	category: Categories.Transforms,
	name: <T>Mirror 4-way (pmm)</T>,
	icon: "repeat_mirror4way",
	value: "5"
}

ModuleUIInfoSetting[ModuleUIInfoSettingTypes.WallpaperRepeats4wayangled] = {
	type: ModuleTypes.WallpaperGroups,
	category: Categories.Transforms,
	name: <T>Mirror 4-way angled (p4m)</T>,
	icon: "repeat_4wayangled",
	value: "10"
}

ModuleUIInfoSetting[ModuleUIInfoSettingTypes.WallpaperRepeatsMirror6way] = {
	type: ModuleTypes.WallpaperGroups,
	category: Categories.Transforms,
	name: <T>Mirror 6-way angled (p6m)</T>,
	icon: "repeat_mirror6way",
	value: "16"
}

export {ModuleUIInfoSetting}